export const PRICELIST_FILTER_WIDTH = 265
export const PRICELIST_WINDOW_SM = 600
export const STATS_WINDOW_SM = 550

export const PRICELIST_FILTER_STEPS = [
    { name: 'id_brand' },
    { name: 'id_category' },
    { name: 'id_subcategory' },
    { name: 'char' },
]

export const LINE_AREA_CHART_OPTIONS = {
    chart: {
        type: 'area',
        stacked: false,
        zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true,
        },
        toolbar: {
            show: false,
        },
    },
    dataLabels: {
        enabled: false,
    },
    markers: {
        size: 0,
        colors: '#2CA3C9',
        strokeDashArray: [5, 5],
    },
    stroke: {
        width: 1,
        colors: ['#2CA3C9'],
    },
    fill: {
        type: 'gradient',
        colors: ['rgba(44, 163, 201, 0.45)'],
        gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.7,
            stops: [0, 100],
            gradientToColors: ['#fff'],
        },
    },
    yaxis: {
        labels: {
            formatter: function (val) {
                return val
            },
            style: {
                cssClass: 'apexcharts-xaxis-label',
            },
        },
        min: 10,
        max: 90000,
    },
    xaxis: {
        type: 'datetime',
        axisBorder: {
            height: 1,
        },
        axisTicks: {
            height: 0,
        },
        labels: {
            style: {
                cssClass: 'apexcharts-xaxis-label',
            },
        },
        max: new Date('2023-04-17 21:00:00').getTime(),
    },
    tooltip: {
        shared: false,
        y: {
            formatter: function (val) {
                return (val / 1000000).toFixed(0)
            },
        },
    },
    grid: {
        borderColor: 'rgba(193, 198, 208, 0.5)',
        strokeDashArray: [4, 8],
    },
}

export const STATISTICS_BAR_PALETTE = {
    rail: '#EBEDF1',
    default: 'rgba(193, 198, 208, 0.2)',
    active: 'linear-gradient(270deg, #E9B837 -24.44%, rgba(232, 182, 51, 0.22) 100.19%)',
}

export const USER_STATUSES = {
    active: 'active',
    not_active: 'not_active',
    blocked: 'blocked',
}

export const STOCK_DATES_TABS_FORMAT = 'YYYY-MM-DD HH:mm:ss'
